var map = {
	"./logo-free.png": "dObA",
	"./logo-gosell.png": "8T9i",
	"./logo-gosellcoth-free.png": "OsMV",
	"./logo-goship.png": "8Vav",
	"./logo-goshipcoth-free.png": "9Yt6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fxfM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/logo\-.*\.png$
// module id = fxfM
// module chunks = 134